import request from 'message-control/utils/request'
import api from 'message-control/common/api/sensitive-notification'

export async function list() {
    return request(api.list.url)
}

export async function update(payload) {
    return request(api.update.url, {
        method: api.update.type,
        body: payload.body,
    })
}
